import * as types from "./actionTypes";

export const showSlabTool = (isShowSlabTool) => ({
  type: types.SHOW_SLAB_TOOL,
  payload: {isShowSlabTool}
});

export const setActiveSlabId = (activeSlabId) => ({
  type: types.SET_ACTIVE_SLAB_ID,
  payload: {activeSlabId}
});

export const setActiveSlabUrl = (activeSlabUrl) => ({
  type: types.SET_ACTIVE_SLAB_URL,
  payload: {activeSlabUrl}
});

export const setActiveStep = (activeStep) => ({
  type: types.SET_SQFT_SLAB_ACTIVE_STEP,
  payload: {activeStep}
});

export const setSlabSearchText = (searchText) => ({
  type: types.SET_SQFT_SLAB_SEARCH_TEXT,
  payload: {searchText}
});

export const setSlabAspectRatio = (slabAspectRatio) => ({
  type: types.SET_SQFT_SLAB_ASPECT_RATIO,
  payload: {slabAspectRatio}
});

export const setSlabImageType = (slabImageType) => ({
  type: types.SET_SLAB_IMAGE_TYPE,
  payload: {slabImageType}
});

export const setSlabImageWidth = (slabImageWidth) => ({
  type: types.SET_SQFT_SLAB_IMAGE_WIDTH,
  payload: {slabImageWidth}
});

export const setSlabImageHeight = (slabImageHeight) => ({
  type: types.SET_SQFT_SLAB_IMAGE_HEIGHT,
  payload: {slabImageHeight}
});

export const setCropperData = (cropperData) => ({
  type: types.SET_SQFT_SLAB_CROPPER_DATA,
  payload: {cropperData}
});

export const setSqftCroppedSlabImages = (croppedSlabImages) => ({
  type: types.SET_SQFT_CROPPED_SLAB_IMAGES,
  payload: {croppedSlabImages}
});

export const addSqftCroppedSlabImage = (croppedSlabImage) => ({
  type: types.ADD_SQFT_CROPPED_SLAB_IMAGE,
  payload: croppedSlabImage
});

export const setSqftSlabToolVisited = (isSlabToolVisited) => ({
  type: types.SET_SLAB_TOOL_VISITED,
  payload: {isSlabToolVisited}
});

export const addRoomWithVisitedSlabTool = (qtCatName) => ({
  type: types.ADD_ROOM_WITH_VISITED_SLAB_TOOL,
  payload: qtCatName
});

export const deleteCroppedSlabImage = (id) => ({
  type: types.DELETE_CROPPED_SLAB_IMAGE,
  payload: {id}
});

export const setPricePerArea = (pricePerArea) => ({
  type: types.SET_PRICE_PER_AREA,
  payload: {pricePerArea}
});

export const setMeasurementVisibleInSlabMode = (isMeasurementVisibleInSlabMode) => ({
  type: types.SET_IS_MEASUREMENT_VISIBLE_IN_SLAB_MODE,
  payload: {isMeasurementVisibleInSlabMode}
});

export const setIsSizeValidationFailed = (isSizeValidationFailed) => ({
  type: types.SET_IS_SIZE_VALIDATION_FAILED,
  payload: {isSizeValidationFailed}
});

export const setIsSlabPricingEnabled = (isSlabPricingEnabled) => ({
  type: types.SET_IS_SLAB_PRICING_ENABLED,
  payload: {isSlabPricingEnabled}
});

export const setSqftSlabConflicts = (sqftSlabConflicts) => ({
  type: types.SET_SQFT_SLAB_CONFLICTS,
  payload: {sqftSlabConflicts}
});
